const WIDGET_ID = "result-esg-sentiment";

export { WIDGET_ID };
